import axios from 'axios';
import store from '../redux/store/store';
const API_XML_URL = import.meta.env.VITE_API_URL;


const StockService = {

    fetchStockFollow: async (userId) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.get(`/StockFollow`, {
                headers: {
                    Authorization: `Bearer ${userToken}`
                },
                params: {  
                    UserId: userId
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching stock follows:', error);
            throw error;
        }
    },


    fetchStock: async (stockFollowId,page) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;
            const response = await axios.get(`/StockFollowRunTimeLog`, {
                 headers: {
                     Authorization: `Bearer ${userToken}` 
                    
                    
                    } ,
                    params: {  
                        stockFollowId: stockFollowId,
                        page:page
                    }
                
                });
            return response.data;
        } catch (error) {
            console.error('Error fetching invoices:', error);
            throw error;
        }
    },



    addStockFollow: async (productData) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.post(
                `${API_XML_URL}/StockFollow`,
                productData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error) {

            console.error("Bir hata oluştu:", error);
            if (error.response && error.response.data) {
                console.error("Hata yanıtı:", error.response.data);
            }
            throw error;
        }
    },


    updateStockFollow: async (productData) => {
        try {
            const userToken = store.getState()?.auth?.user?.accessToken?.token;

            const response = await axios.put(
                `${API_XML_URL}/StockFollow`,
                productData,
                {
                    headers: {
                        Authorization: `Bearer ${userToken}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            return response.data;
        } catch (error) {

            console.error("Bir hata oluştu:", error);
            if (error.response && error.response.data) {
                console.error("Hata yanıtı:", error.response.data);
            }
            throw error;
        }
    },

}
export default StockService;